import { Component, OnInit, OnChanges, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
declare var $:any;

@Component({
  selector: 'custom-component',
  templateUrl: './custom.component.html',
  styleUrls: ['./custom.component.scss']
})
export class CustomComponent implements OnInit, OnChanges, OnDestroy {

  @Input('customHtml')customHtml;
  @Input('responseUuid')responseUuid;

  @Output() uuid: EventEmitter<any> = new EventEmitter();

  private idiomaCheckInterval: any;
  private ultimoIdioma: string = null;

  constructor() { }

  ngOnInit() {
    this.actualizarClaseIdioma();

    // El switch de idioma (header) solo hace localStorage.setItem, sin
    // emitir ningún evento hacia este componente ni disparar un cambio
    // de @Input, así que ngOnChanges no se entera del cambio. Para que
    // la imagen del banner (y cualquier otro estilo condicional por
    // idioma) reaccione en tiempo real, se vigila el valor en localStorage
    // con un polling liviano mientras el componente está activo.
    this.idiomaCheckInterval = setInterval(() => this.actualizarClaseIdioma(), 300);
  }

  ngOnChanges() {
    this.actualizarClaseIdioma();
  }

  ngOnDestroy() {
    if (this.idiomaCheckInterval) {
      clearInterval(this.idiomaCheckInterval);
    }
  }

  // Agrega/quita una clase en <body> según el idioma activo, para poder
  // aplicar estilos condicionales (ej. imágenes en inglés) desde CSS
  // global sin depender de que el backend devuelva markup distinto.
  private actualizarClaseIdioma() {
    const valorActual = this.readLocalStorageValue('idiomaEspañol');
    if (valorActual === this.ultimoIdioma) {
      return;
    }
    this.ultimoIdioma = valorActual;

    const esIngles = valorActual === 'true';
    if (esIngles) {
      document.body.classList.add('lang-en');
    } else {
      document.body.classList.remove('lang-en');
    }
  }

  redireccionarAPaginaExistente(uuid){
    
    this.uuid.emit(uuid);
    $(".lg-menu").fadeOut();
  }

  readLocalStorageValue(key) {
    return localStorage.getItem(key);
}


}
